export default "__VITE_ASSET__d1b8a9d3__"